import jwtDecode, { JwtPayload } from "jwt-decode";

export const parseJwt = (token: string) => {
  return jwtDecode<JwtPayload>(token);
};
